import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-center items-center fixed inset-y-0 right-0 overflow-x-hidden overflow-y-hidden z-50 w-full"
}
const _hoisted_2 = { class: "flex relative w-1/2 h-auto" }
const _hoisted_3 = { class: "flex flex-col bg-white w-full h-auto rounded-2xl shadow p-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-2xl text-center" }, " Please add a payment method ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-center mt-2" }, " Before you can use the platform you need to first register a payment method ", -1)
const _hoisted_6 = { class: "flex flex-row justify-center mt-8" }
const _hoisted_7 = {
  key: 1,
  class: "bg-black opacity-50 fixed inset-y-0 right-0 z-40 w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.openModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addCard && _ctx.addCard(...args))),
                  class: "btn-filled-lg"
                }, " Add a payment method ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.openModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7))
      : _createCommentVNode("", true)
  ]))
}